module.exports = __webpack_public_path__ + "static/img/css.3675c79c.png";